import "../../../assets/RideTextField.css";
import { RideErrorMessage as ne } from "../error-message/RideErrorMessage.js";
import D, { forwardRef as ae, useState as Vt, useRef as ue, useEffect as Pt, useImperativeHandle as oe, cloneElement as Ct } from "react";
import At from "clsx";
import le from "lodash.uniqueid";
import { RideSpinner as he } from "../spinner/RideSpinner.js";
import { maskTemplates as pe } from "./utils/mask-templates.js";
function ce(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
const de = [
  "email",
  "number",
  "password",
  "tel",
  "text"
], fe = "_input_12twg_6", me = "_spinner_12twg_64", ge = "_label_12twg_67", _e = "_optional_12twg_79", ve = "_small_12twg_108", ke = "_prefix_12twg_126", Ee = "_suffix_12twg_127", ye = "_error_12twg_134", Ce = "_medium_12twg_137", Ae = "_large_12twg_147", be = "_disabled_12twg_210", xe = "_loading_12twg_211", V = {
  "ride-text-field": "_ride-text-field_12twg_1",
  "input-container": "_input-container_12twg_6",
  input: fe,
  "glyph-container": "_glyph-container_12twg_54",
  spinner: me,
  label: ge,
  optional: _e,
  "helper-container": "_helper-container_12twg_87",
  "helper-text": "_helper-text_12twg_90",
  "character-counter": "_character-counter_12twg_99",
  small: ve,
  prefix: ke,
  suffix: Ee,
  error: ye,
  medium: Ce,
  large: Ae,
  "glyph-button": "_glyph-button_12twg_161",
  "glyph-left": "_glyph-left_12twg_174",
  "glyph-right": "_glyph-right_12twg_177",
  disabled: be,
  loading: xe
};
function it(a) {
  return typeof a == "string" || a instanceof String;
}
function Lt(a) {
  var t;
  return typeof a == "object" && a != null && (a == null || (t = a.constructor) == null ? void 0 : t.name) === "Object";
}
function Wt(a, t) {
  return Array.isArray(t) ? Wt(a, (e, s) => t.includes(s)) : Object.entries(a).reduce((e, s) => {
    let [i, r] = s;
    return t(r, i) && (e[i] = r), e;
  }, {});
}
const g = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function Fe(a) {
  switch (a) {
    case g.LEFT:
      return g.FORCE_LEFT;
    case g.RIGHT:
      return g.FORCE_RIGHT;
    default:
      return a;
  }
}
function bt(a) {
  return a.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function gt(a, t) {
  if (t === a) return !0;
  const e = Array.isArray(t), s = Array.isArray(a);
  let i;
  if (e && s) {
    if (t.length != a.length) return !1;
    for (i = 0; i < t.length; i++) if (!gt(t[i], a[i])) return !1;
    return !0;
  }
  if (e != s) return !1;
  if (t && a && typeof t == "object" && typeof a == "object") {
    const r = t instanceof Date, n = a instanceof Date;
    if (r && n) return t.getTime() == a.getTime();
    if (r != n) return !1;
    const u = t instanceof RegExp, l = a instanceof RegExp;
    if (u && l) return t.toString() == a.toString();
    if (u != l) return !1;
    const h = Object.keys(t);
    for (i = 0; i < h.length; i++) if (!Object.prototype.hasOwnProperty.call(a, h[i])) return !1;
    for (i = 0; i < h.length; i++) if (!gt(a[h[i]], t[h[i]])) return !1;
    return !0;
  } else if (t && a && typeof t == "function" && typeof a == "function")
    return t.toString() === a.toString();
  return !1;
}
class Se {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(t) {
    for (Object.assign(this, t); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
    if (this.insertedCount)
      for (; this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end); )
        this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end ? ++this.oldSelection.end : ++this.cursorPos;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? g.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? g.RIGHT : g.LEFT;
  }
}
function k(a, t) {
  return new k.InputMask(a, t);
}
function Zt(a) {
  if (a == null) throw new Error("mask property should be defined");
  return a instanceof RegExp ? k.MaskedRegExp : it(a) ? k.MaskedPattern : a === Date ? k.MaskedDate : a === Number ? k.MaskedNumber : Array.isArray(a) || a === Array ? k.MaskedDynamic : k.Masked && a.prototype instanceof k.Masked ? a : k.Masked && a instanceof k.Masked ? a.constructor : a instanceof Function ? k.MaskedFunction : (console.warn("Mask not found for mask", a), k.Masked);
}
function ct(a) {
  if (!a) throw new Error("Options in not defined");
  if (k.Masked) {
    if (a.prototype instanceof k.Masked) return {
      mask: a
    };
    const {
      mask: t = void 0,
      ...e
    } = a instanceof k.Masked ? {
      mask: a
    } : Lt(a) && a.mask instanceof k.Masked ? a : {};
    if (t) {
      const s = t.mask;
      return {
        ...Wt(t, (i, r) => !r.startsWith("_")),
        mask: t.constructor,
        _mask: s,
        ...e
      };
    }
  }
  return Lt(a) ? {
    ...a
  } : {
    mask: a
  };
}
function tt(a) {
  if (k.Masked && a instanceof k.Masked) return a;
  const t = ct(a), e = Zt(t.mask);
  if (!e) throw new Error("Masked class is not found for provided mask " + t.mask + ", appropriate module needs to be imported manually before creating mask.");
  return t.mask === e && delete t.mask, t._mask && (t.mask = t._mask, delete t._mask), new e(t);
}
k.createMask = tt;
class Mt {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let t;
    try {
      t = this._unsafeSelectionStart;
    } catch {
    }
    return t ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let t;
    try {
      t = this._unsafeSelectionEnd;
    } catch {
    }
    return t ?? this.value.length;
  }
  /** Safely sets element selection */
  select(t, e) {
    if (!(t == null || e == null || t === this.selectionStart && e === this.selectionEnd))
      try {
        this._unsafeSelect(t, e);
      } catch {
      }
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
k.MaskElement = Mt;
const Nt = 90, Te = 89;
class vt extends Mt {
  /** HTMLElement to use mask on */
  constructor(t) {
    super(), this.input = t, this._onKeydown = this._onKeydown.bind(this), this._onInput = this._onInput.bind(this), this._onBeforeinput = this._onBeforeinput.bind(this), this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var t, e, s;
    return (t = (e = (s = this.input).getRootNode) == null ? void 0 : e.call(s)) != null ? t : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(t) {
    this.input.addEventListener("keydown", this._onKeydown), this.input.addEventListener("input", this._onInput), this.input.addEventListener("beforeinput", this._onBeforeinput), this.input.addEventListener("compositionend", this._onCompositionEnd), this.input.addEventListener("drop", t.drop), this.input.addEventListener("click", t.click), this.input.addEventListener("focus", t.focus), this.input.addEventListener("blur", t.commit), this._handlers = t;
  }
  _onKeydown(t) {
    if (this._handlers.redo && (t.keyCode === Nt && t.shiftKey && (t.metaKey || t.ctrlKey) || t.keyCode === Te && t.ctrlKey))
      return t.preventDefault(), this._handlers.redo(t);
    if (this._handlers.undo && t.keyCode === Nt && (t.metaKey || t.ctrlKey))
      return t.preventDefault(), this._handlers.undo(t);
    t.isComposing || this._handlers.selectionChange(t);
  }
  _onBeforeinput(t) {
    if (t.inputType === "historyUndo" && this._handlers.undo)
      return t.preventDefault(), this._handlers.undo(t);
    if (t.inputType === "historyRedo" && this._handlers.redo)
      return t.preventDefault(), this._handlers.redo(t);
  }
  _onCompositionEnd(t) {
    this._handlers.input(t);
  }
  _onInput(t) {
    t.isComposing || this._handlers.input(t);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown), this.input.removeEventListener("input", this._onInput), this.input.removeEventListener("beforeinput", this._onBeforeinput), this.input.removeEventListener("compositionend", this._onCompositionEnd), this.input.removeEventListener("drop", this._handlers.drop), this.input.removeEventListener("click", this._handlers.click), this.input.removeEventListener("focus", this._handlers.focus), this.input.removeEventListener("blur", this._handlers.commit), this._handlers = {};
  }
}
k.HTMLMaskElement = vt;
class we extends vt {
  /** InputElement to use mask on */
  constructor(t) {
    super(t), this.input = t;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(t, e) {
    this.input.setSelectionRange(t, e);
  }
  get value() {
    return this.input.value;
  }
  set value(t) {
    this.input.value = t;
  }
}
k.HTMLMaskElement = vt;
class Xt extends vt {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const t = this.rootElement, e = t.getSelection && t.getSelection(), s = e && e.anchorOffset, i = e && e.focusOffset;
    return i == null || s == null || s < i ? s : i;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const t = this.rootElement, e = t.getSelection && t.getSelection(), s = e && e.anchorOffset, i = e && e.focusOffset;
    return i == null || s == null || s > i ? s : i;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(t, e) {
    if (!this.rootElement.createRange) return;
    const s = this.rootElement.createRange();
    s.setStart(this.input.firstChild || this.input, t), s.setEnd(this.input.lastChild || this.input, e);
    const i = this.rootElement, r = i.getSelection && i.getSelection();
    r && (r.removeAllRanges(), r.addRange(s));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(t) {
    this.input.textContent = t;
  }
}
k.HTMLContenteditableMaskElement = Xt;
class kt {
  constructor() {
    this.states = [], this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(t) {
    this.currentIndex < this.states.length - 1 && (this.states.length = this.currentIndex + 1), this.states.push(t), this.states.length > kt.MAX_LENGTH && this.states.shift(), this.currentIndex = this.states.length - 1;
  }
  go(t) {
    return this.currentIndex = Math.min(Math.max(this.currentIndex + t, 0), this.states.length - 1), this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0, this.currentIndex = 0;
  }
}
kt.MAX_LENGTH = 100;
class Ie {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(t, e) {
    this.el = t instanceof Mt ? t : t.isContentEditable && t.tagName !== "INPUT" && t.tagName !== "TEXTAREA" ? new Xt(t) : new we(t), this.masked = tt(e), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._rawInputValue = "", this.history = new kt(), this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this._onUndo = this._onUndo.bind(this), this._onRedo = this._onRedo.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(t) {
    var e;
    return t == null || ((e = this.masked) == null ? void 0 : e.maskEquals(t));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(t) {
    if (this.maskEquals(t)) return;
    if (!(t instanceof k.Masked) && this.masked.constructor === Zt(t)) {
      this.masked.updateOptions({
        mask: t
      });
      return;
    }
    const e = t instanceof k.Masked ? t : tt({
      mask: t
    });
    e.unmaskedValue = this.masked.unmaskedValue, this.masked = e;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(t) {
    this.value !== t && (this.masked.value = t, this.updateControl("auto"));
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(t) {
    this.unmaskedValue !== t && (this.masked.unmaskedValue = t, this.updateControl("auto"));
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(t) {
    this.rawInputValue !== t && (this.masked.rawInputValue = t, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(t) {
    this.masked.typedValueEquals(t) || (this.masked.typedValue = t, this.updateControl("auto"));
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(t, e) {
    const s = this._listeners[t];
    s && s.forEach((i) => i(e));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(t) {
    !this.el || !this.el.isActive || (this.el.select(t, t), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value, this._unmaskedValue = this.masked.unmaskedValue, this._rawInputValue = this.masked.rawInputValue;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(t) {
    const e = this.masked.unmaskedValue, s = this.masked.value, i = this.masked.rawInputValue, r = this.displayValue, n = this.unmaskedValue !== e || this.value !== s || this._rawInputValue !== i;
    this._unmaskedValue = e, this._value = s, this._rawInputValue = i, this.el.value !== r && (this.el.value = r), t === "auto" ? this.alignCursor() : t != null && (this.cursorPos = t), n && this._fireChangeEvents(), !this._historyChanging && (n || this.history.isEmpty) && this.history.push({
      unmaskedValue: e,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(t) {
    const {
      mask: e,
      ...s
    } = t, i = !this.maskEquals(e), r = this.masked.optionsIsChanged(s);
    i && (this.mask = e), r && this.masked.updateOptions(s), (i || r) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(t) {
    t != null && (this.cursorPos = t, this._delayUpdateCursor(t));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(t) {
    this._abortUpdateCursor(), this._changingCursorPos = t, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, g.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(t, e) {
    return this._listeners[t] || (this._listeners[t] = []), this._listeners[t].push(e), this;
  }
  /** Removes custom event listener */
  off(t, e) {
    if (!this._listeners[t]) return this;
    if (!e)
      return delete this._listeners[t], this;
    const s = this._listeners[t].indexOf(e);
    return s >= 0 && this._listeners[t].splice(s, 1), this;
  }
  /** Handles view input event */
  _onInput(t) {
    this._inputEvent = t, this._abortUpdateCursor();
    const e = new Se({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    }), s = this.masked.rawInputValue, i = this.masked.splice(e.startChangePos, e.removed.length, e.inserted, e.removeDirection, {
      input: !0,
      raw: !0
    }).offset, r = s === this.masked.rawInputValue ? e.removeDirection : g.NONE;
    let n = this.masked.nearestInputPos(e.startChangePos + i, r);
    r !== g.NONE && (n = this.masked.nearestInputPos(n, g.NONE)), this.updateControl(n), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(t) {
    t.preventDefault(), t.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(t) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(t) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(t) {
    t && (this._historyChanging = !0, this.unmaskedValue = t.unmaskedValue, this.el.select(t.selection.start, t.selection.end), this._saveSelection(), this._historyChanging = !1);
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
k.InputMask = Ie;
class C {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(t) {
    return Array.isArray(t) ? t : [t, new C()];
  }
  constructor(t) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: !1
    }, t);
  }
  /** Aggregate changes */
  aggregate(t) {
    return this.inserted += t.inserted, this.rawInserted += t.rawInserted, this.tailShift += t.tailShift, this.skip = this.skip || t.skip, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return !!this.rawInserted || this.skip;
  }
  equals(t) {
    return this.inserted === t.inserted && this.tailShift === t.tailShift && this.rawInserted === t.rawInserted && this.skip === t.skip;
  }
}
k.ChangeDetails = C;
class Z {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(t, e, s) {
    t === void 0 && (t = ""), e === void 0 && (e = 0), this.value = t, this.from = e, this.stop = s;
  }
  toString() {
    return this.value;
  }
  extend(t) {
    this.value += String(t);
  }
  appendTo(t) {
    return t.append(this.toString(), {
      tail: !0
    }).aggregate(t._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(t) {
    Object.assign(this, t);
  }
  unshift(t) {
    if (!this.value.length || t != null && this.from >= t) return "";
    const e = this.value[0];
    return this.value = this.value.slice(1), e;
  }
  shift() {
    if (!this.value.length) return "";
    const t = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), t;
  }
}
class $ {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(t) {
    this._value = "", this._update({
      ...$.DEFAULTS,
      ...t
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(t) {
    this.optionsIsChanged(t) && this.withValueRefresh(this._update.bind(this, t));
  }
  /** Sets new options */
  _update(t) {
    Object.assign(this, t);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(t) {
    this._value = t._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(t) {
    this.resolve(t, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(t, e) {
    e === void 0 && (e = {
      input: !0
    }), this.reset(), this.append(t, e, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(t) {
    this.resolve(t, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(t) {
    this.format ? this.value = this.format(t, this) : this.unmaskedValue = String(t);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(t) {
    this.resolve(t, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(t, e) {
    return t;
  }
  totalInputPositions(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), Math.min(this.displayValue.length, e - t);
  }
  /** Extracts value in range considering flags */
  extractInput(t, e, s) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), this.displayValue.slice(t, e);
  }
  /** Extracts tail in range */
  extractTail(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), new Z(this.extractInput(t, e), t);
  }
  /** Appends tail */
  appendTail(t) {
    return it(t) && (t = new Z(String(t))), t.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(t, e) {
    return t ? (this._value += t, new C({
      inserted: t,
      rawInserted: t
    })) : new C();
  }
  /** Appends char */
  _appendChar(t, e, s) {
    e === void 0 && (e = {});
    const i = this.state;
    let r;
    if ([t, r] = this.doPrepareChar(t, e), t && (r = r.aggregate(this._appendCharRaw(t, e)), !r.rawInserted && this.autofix === "pad")) {
      const n = this.state;
      this.state = i;
      let u = this.pad(e);
      const l = this._appendCharRaw(t, e);
      u = u.aggregate(l), l.rawInserted || u.equals(r) ? r = u : this.state = n;
    }
    if (r.inserted) {
      let n, u = this.doValidate(e) !== !1;
      if (u && s != null) {
        const l = this.state;
        if (this.overwrite === !0) {
          n = s.state;
          for (let _ = 0; _ < r.rawInserted.length; ++_)
            s.unshift(this.displayValue.length - r.tailShift);
        }
        let h = this.appendTail(s);
        if (u = h.rawInserted.length === s.toString().length, !(u && h.inserted) && this.overwrite === "shift") {
          this.state = l, n = s.state;
          for (let _ = 0; _ < r.rawInserted.length; ++_)
            s.shift();
          h = this.appendTail(s), u = h.rawInserted.length === s.toString().length;
        }
        u && h.inserted && (this.state = l);
      }
      u || (r = new C(), this.state = i, s && n && (s.state = n));
    }
    return r;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new C();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new C();
  }
  /** Appends symbols considering flags */
  append(t, e, s) {
    if (!it(t)) throw new Error("value should be string");
    const i = it(s) ? new Z(String(s)) : s;
    e != null && e.tail && (e._beforeTailState = this.state);
    let r;
    [t, r] = this.doPrepare(t, e);
    for (let n = 0; n < t.length; ++n) {
      const u = this._appendChar(t[n], e, i);
      if (!u.rawInserted && !this.doSkipInvalid(t[n], e, i)) break;
      r.aggregate(u);
    }
    return (this.eager === !0 || this.eager === "append") && e != null && e.input && t && r.aggregate(this._appendEager()), i != null && (r.tailShift += this.appendTail(i).tailShift), r;
  }
  remove(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), this._value = this.displayValue.slice(0, t) + this.displayValue.slice(e), new C();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(t) {
    if (this._refreshing || !this._initialized) return t();
    this._refreshing = !0;
    const e = this.rawInputValue, s = this.value, i = t();
    return this.rawInputValue = e, this.value && this.value !== s && s.indexOf(this.value) === 0 && (this.append(s.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, i;
  }
  runIsolated(t) {
    if (this._isolated || !this._initialized) return t(this);
    this._isolated = !0;
    const e = this.state, s = t(this);
    return this.state = e, delete this._isolated, s;
  }
  doSkipInvalid(t, e, s) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(t, e) {
    return e === void 0 && (e = {}), C.normalize(this.prepare ? this.prepare(t, this, e) : t);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(t, e) {
    return e === void 0 && (e = {}), C.normalize(this.prepareChar ? this.prepareChar(t, this, e) : t);
  }
  /** Validates if value is acceptable */
  doValidate(t) {
    return (!this.validate || this.validate(this.value, this, t)) && (!this.parent || this.parent.doValidate(t));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(t, e, s, i, r) {
    s === void 0 && (s = ""), i === void 0 && (i = g.NONE), r === void 0 && (r = {
      input: !0
    });
    const n = t + e, u = this.extractTail(n), l = this.eager === !0 || this.eager === "remove";
    let h;
    l && (i = Fe(i), h = this.extractInput(0, n, {
      raw: !0
    }));
    let _ = t;
    const v = new C();
    if (i !== g.NONE && (_ = this.nearestInputPos(t, e > 1 && t !== 0 && !l ? g.NONE : i), v.tailShift = _ - t), v.aggregate(this.remove(_)), l && i !== g.NONE && h === this.rawInputValue)
      if (i === g.FORCE_LEFT) {
        let S;
        for (; h === this.rawInputValue && (S = this.displayValue.length); )
          v.aggregate(new C({
            tailShift: -1
          })).aggregate(this.remove(S - 1));
      } else i === g.FORCE_RIGHT && u.unshift();
    return v.aggregate(this.append(s, r, u));
  }
  maskEquals(t) {
    return this.mask === t;
  }
  optionsIsChanged(t) {
    return !gt(this, t);
  }
  typedValueEquals(t) {
    const e = this.typedValue;
    return t === e || $.EMPTY_VALUES.includes(t) && $.EMPTY_VALUES.includes(e) || (this.format ? this.format(t, this) === this.format(this.typedValue, this) : !1);
  }
  pad(t) {
    return new C();
  }
}
$.DEFAULTS = {
  skipInvalid: !0
};
$.EMPTY_VALUES = [void 0, null, ""];
k.Masked = $;
class nt {
  /** */
  constructor(t, e) {
    t === void 0 && (t = []), e === void 0 && (e = 0), this.chunks = t, this.from = e;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(t) {
    if (!String(t)) return;
    t = it(t) ? new Z(String(t)) : t;
    const e = this.chunks[this.chunks.length - 1], s = e && // if stops are same or tail has no stop
    (e.stop === t.stop || t.stop == null) && // if tail chunk goes just after last chunk
    t.from === e.from + e.toString().length;
    if (t instanceof Z)
      s ? e.extend(t.toString()) : this.chunks.push(t);
    else if (t instanceof nt) {
      if (t.stop == null) {
        let i;
        for (; t.chunks.length && t.chunks[0].stop == null; )
          i = t.chunks.shift(), i.from += t.from, this.extend(i);
      }
      t.toString() && (t.stop = t.blockIndex, this.chunks.push(t));
    }
  }
  appendTo(t) {
    if (!(t instanceof k.MaskedPattern))
      return new Z(this.toString()).appendTo(t);
    const e = new C();
    for (let s = 0; s < this.chunks.length; ++s) {
      const i = this.chunks[s], r = t._mapPosToBlock(t.displayValue.length), n = i.stop;
      let u;
      if (n != null && // if block not found or stop is behind lastBlock
      (!r || r.index <= n) && ((i instanceof nt || // for continuous block also check if stop is exist
      t._stops.indexOf(n) >= 0) && e.aggregate(t._appendPlaceholder(n)), u = i instanceof nt && t._blocks[n]), u) {
        const l = u.appendTail(i);
        e.aggregate(l);
        const h = i.toString().slice(l.rawInserted.length);
        h && e.aggregate(t.append(h, {
          tail: !0
        }));
      } else
        e.aggregate(t.append(i.toString(), {
          tail: !0
        }));
    }
    return e;
  }
  get state() {
    return {
      chunks: this.chunks.map((t) => t.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(t) {
    const {
      chunks: e,
      ...s
    } = t;
    Object.assign(this, s), this.chunks = e.map((i) => {
      const r = "chunks" in i ? new nt() : new Z();
      return r.state = i, r;
    });
  }
  unshift(t) {
    if (!this.chunks.length || t != null && this.from >= t) return "";
    const e = t != null ? t - this.from : t;
    let s = 0;
    for (; s < this.chunks.length; ) {
      const i = this.chunks[s], r = i.unshift(e);
      if (i.toString()) {
        if (!r) break;
        ++s;
      } else
        this.chunks.splice(s, 1);
      if (r) return r;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length) return "";
    let t = this.chunks.length - 1;
    for (; 0 <= t; ) {
      const e = this.chunks[t], s = e.shift();
      if (e.toString()) {
        if (!s) break;
        --t;
      } else
        this.chunks.splice(t, 1);
      if (s) return s;
    }
    return "";
  }
}
class Re {
  constructor(t, e) {
    this.masked = t, this._log = [];
    const {
      offset: s,
      index: i
    } = t._mapPosToBlock(e) || (e < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = s, this.index = i, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(t) {
    Object.assign(this, t);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const t = this._log.pop();
    return t && (this.state = t), t;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(t) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((e = this.block) == null ? void 0 : e.displayValue.length) || 0) {
      var e;
      if (t()) return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(t) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (t()) return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, g.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, g.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, g.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, g.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, g.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, g.NONE), !0;
    });
  }
}
class Jt {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(t) {
    Object.assign(this, t), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this._value.length), this._value = this._value.slice(0, t) + this._value.slice(e), this._value || (this._isRawInput = !1), new C();
  }
  nearestInputPos(t, e) {
    e === void 0 && (e = g.NONE);
    const s = 0, i = this._value.length;
    switch (e) {
      case g.LEFT:
      case g.FORCE_LEFT:
        return s;
      case g.NONE:
      case g.RIGHT:
      case g.FORCE_RIGHT:
      default:
        return i;
    }
  }
  totalInputPositions(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this._value.length), this._isRawInput ? e - t : 0;
  }
  extractInput(t, e, s) {
    return t === void 0 && (t = 0), e === void 0 && (e = this._value.length), s === void 0 && (s = {}), s.raw && this._isRawInput && this._value.slice(t, e) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(t, e) {
    if (e === void 0 && (e = {}), this.isFilled) return new C();
    const s = this.eager === !0 || this.eager === "append", r = this.char === t && (this.isUnmasking || e.input || e.raw) && (!e.raw || !s) && !e.tail, n = new C({
      inserted: this.char,
      rawInserted: r ? this.char : ""
    });
    return this._value = this.char, this._isRawInput = r && (e.raw || e.input), n;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const t = new C();
    return this.isFilled || (this._value = t.inserted = this.char), t;
  }
  extractTail() {
    return new Z("");
  }
  appendTail(t) {
    return it(t) && (t = new Z(String(t))), t.appendTo(this);
  }
  append(t, e, s) {
    const i = this._appendChar(t[0], e);
    return s != null && (i.tailShift += this.appendTail(s).tailShift), i;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(t) {
    this._value = t._value, this._isRawInput = !!t._rawInputValue;
  }
  pad(t) {
    return this._appendPlaceholder();
  }
}
class _t {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(t) {
    const {
      parent: e,
      isOptional: s,
      placeholderChar: i,
      displayChar: r,
      lazy: n,
      eager: u,
      ...l
    } = t;
    this.masked = tt(l), Object.assign(this, {
      parent: e,
      isOptional: s,
      placeholderChar: i,
      displayChar: r,
      lazy: n,
      eager: u
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.value.length), t === 0 && e >= 1 ? (this.isFilled = !1, this.masked.remove(t, e)) : new C();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(t, e) {
    if (e === void 0 && (e = {}), this.isFilled) return new C();
    const s = this.masked.state;
    let i = this.masked._appendChar(t, this.currentMaskFlags(e));
    return i.inserted && this.doValidate(e) === !1 && (i = new C(), this.masked.state = s), !i.inserted && !this.isOptional && !this.lazy && !e.input && (i.inserted = this.placeholderChar), i.skip = !i.inserted && !this.isOptional, this.isFilled = !!i.inserted, i;
  }
  append(t, e, s) {
    return this.masked.append(t, this.currentMaskFlags(e), s);
  }
  _appendPlaceholder() {
    return this.isFilled || this.isOptional ? new C() : (this.isFilled = !0, new C({
      inserted: this.placeholderChar
    }));
  }
  _appendEager() {
    return new C();
  }
  extractTail(t, e) {
    return this.masked.extractTail(t, e);
  }
  appendTail(t) {
    return this.masked.appendTail(t);
  }
  extractInput(t, e, s) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.value.length), this.masked.extractInput(t, e, s);
  }
  nearestInputPos(t, e) {
    e === void 0 && (e = g.NONE);
    const s = 0, i = this.value.length, r = Math.min(Math.max(t, s), i);
    switch (e) {
      case g.LEFT:
      case g.FORCE_LEFT:
        return this.isComplete ? r : s;
      case g.RIGHT:
      case g.FORCE_RIGHT:
        return this.isComplete ? r : i;
      case g.NONE:
      default:
        return r;
    }
  }
  totalInputPositions(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.value.length), this.value.slice(t, e).length;
  }
  doValidate(t) {
    return this.masked.doValidate(this.currentMaskFlags(t)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(t)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(t) {
    this.masked.state = t.masked, this.isFilled = t.isFilled;
  }
  currentMaskFlags(t) {
    var e;
    return {
      ...t,
      _beforeTailState: (t == null || (e = t._beforeTailState) == null ? void 0 : e.masked) || (t == null ? void 0 : t._beforeTailState)
    };
  }
  pad(t) {
    return new C();
  }
}
_t.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class Be extends $ {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    const e = t.mask;
    e && (t.validate = (s) => s.search(e) >= 0), super._update(t);
  }
}
k.MaskedRegExp = Be;
class q extends $ {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(t) {
    super({
      ...q.DEFAULTS,
      ...t,
      definitions: Object.assign({}, _t.DEFAULT_DEFINITIONS, t == null ? void 0 : t.definitions)
    });
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    t.definitions = Object.assign({}, this.definitions, t.definitions), super._update(t), this._rebuildMask();
  }
  _rebuildMask() {
    const t = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const e = this.mask;
    if (!e || !t) return;
    let s = !1, i = !1;
    for (let r = 0; r < e.length; ++r) {
      if (this.blocks) {
        const h = e.slice(r), _ = Object.keys(this.blocks).filter((S) => h.indexOf(S) === 0);
        _.sort((S, R) => R.length - S.length);
        const v = _[0];
        if (v) {
          const {
            expose: S,
            repeat: R,
            ...P
          } = ct(this.blocks[v]), I = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...P,
            repeat: R,
            parent: this
          }, O = R != null ? new k.RepeatBlock(
            I
            /* TODO */
          ) : tt(I);
          O && (this._blocks.push(O), S && (this.exposeBlock = O), this._maskedBlocks[v] || (this._maskedBlocks[v] = []), this._maskedBlocks[v].push(this._blocks.length - 1)), r += v.length - 1;
          continue;
        }
      }
      let n = e[r], u = n in t;
      if (n === q.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (n === "{" || n === "}") {
        s = !s;
        continue;
      }
      if (n === "[" || n === "]") {
        i = !i;
        continue;
      }
      if (n === q.ESCAPE_CHAR) {
        if (++r, n = e[r], !n) break;
        u = !1;
      }
      const l = u ? new _t({
        isOptional: i,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...ct(t[n]),
        parent: this
      }) : new Jt({
        char: n,
        eager: this.eager,
        isUnmasking: s
      });
      this._blocks.push(l);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((t) => t.state)
    };
  }
  set state(t) {
    if (!t) {
      this.reset();
      return;
    }
    const {
      _blocks: e,
      ...s
    } = t;
    this._blocks.forEach((i, r) => i.state = e[r]), super.state = s;
  }
  reset() {
    super.reset(), this._blocks.forEach((t) => t.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((t) => t.isComplete);
  }
  get isFilled() {
    return this._blocks.every((t) => t.isFilled);
  }
  get isFixed() {
    return this._blocks.every((t) => t.isFixed);
  }
  get isOptional() {
    return this._blocks.every((t) => t.isOptional);
  }
  doCommit() {
    this._blocks.forEach((t) => t.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((t, e) => t += e.unmaskedValue, "");
  }
  set unmaskedValue(t) {
    if (this.exposeBlock) {
      const e = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = t, this.appendTail(e), this.doCommit();
    } else super.unmaskedValue = t;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((t, e) => t += e.value, "")
    );
  }
  set value(t) {
    if (this.exposeBlock) {
      const e = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = t, this.appendTail(e), this.doCommit();
    } else super.value = t;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(t) {
    if (this.exposeBlock) {
      const e = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = t, this.appendTail(e), this.doCommit();
    } else super.typedValue = t;
  }
  get displayValue() {
    return this._blocks.reduce((t, e) => t += e.displayValue, "");
  }
  appendTail(t) {
    return super.appendTail(t).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var t;
    const e = new C();
    let s = (t = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : t.index;
    if (s == null) return e;
    this._blocks[s].isFilled && ++s;
    for (let i = s; i < this._blocks.length; ++i) {
      const r = this._blocks[i]._appendEager();
      if (!r.inserted) break;
      e.aggregate(r);
    }
    return e;
  }
  _appendCharRaw(t, e) {
    e === void 0 && (e = {});
    const s = this._mapPosToBlock(this.displayValue.length), i = new C();
    if (!s) return i;
    for (let n = s.index, u; u = this._blocks[n]; ++n) {
      var r;
      const l = u._appendChar(t, {
        ...e,
        _beforeTailState: (r = e._beforeTailState) == null || (r = r._blocks) == null ? void 0 : r[n]
      });
      if (i.aggregate(l), l.consumed) break;
    }
    return i;
  }
  extractTail(t, e) {
    t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length);
    const s = new nt();
    return t === e || this._forEachBlocksInRange(t, e, (i, r, n, u) => {
      const l = i.extractTail(n, u);
      l.stop = this._findStopBefore(r), l.from = this._blockStartPos(r), l instanceof nt && (l.blockIndex = r), s.extend(l);
    }), s;
  }
  extractInput(t, e, s) {
    if (t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), s === void 0 && (s = {}), t === e) return "";
    let i = "";
    return this._forEachBlocksInRange(t, e, (r, n, u, l) => {
      i += r.extractInput(u, l, s);
    }), i;
  }
  _findStopBefore(t) {
    let e;
    for (let s = 0; s < this._stops.length; ++s) {
      const i = this._stops[s];
      if (i <= t) e = i;
      else break;
    }
    return e;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(t) {
    const e = new C();
    if (this.lazy && t == null) return e;
    const s = this._mapPosToBlock(this.displayValue.length);
    if (!s) return e;
    const i = s.index, r = t ?? this._blocks.length;
    return this._blocks.slice(i, r).forEach((n) => {
      if (!n.lazy || t != null) {
        var u;
        e.aggregate(n._appendPlaceholder((u = n._blocks) == null ? void 0 : u.length));
      }
    }), e;
  }
  /** Finds block in pos */
  _mapPosToBlock(t) {
    let e = "";
    for (let s = 0; s < this._blocks.length; ++s) {
      const i = this._blocks[s], r = e.length;
      if (e += i.displayValue, t <= e.length)
        return {
          index: s,
          offset: t - r
        };
    }
  }
  _blockStartPos(t) {
    return this._blocks.slice(0, t).reduce((e, s) => e += s.displayValue.length, 0);
  }
  _forEachBlocksInRange(t, e, s) {
    e === void 0 && (e = this.displayValue.length);
    const i = this._mapPosToBlock(t);
    if (i) {
      const r = this._mapPosToBlock(e), n = r && i.index === r.index, u = i.offset, l = r && n ? r.offset : this._blocks[i.index].displayValue.length;
      if (s(this._blocks[i.index], i.index, u, l), r && !n) {
        for (let h = i.index + 1; h < r.index; ++h)
          s(this._blocks[h], h, 0, this._blocks[h].displayValue.length);
        s(this._blocks[r.index], r.index, 0, r.offset);
      }
    }
  }
  remove(t, e) {
    t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length);
    const s = super.remove(t, e);
    return this._forEachBlocksInRange(t, e, (i, r, n, u) => {
      s.aggregate(i.remove(n, u));
    }), s;
  }
  nearestInputPos(t, e) {
    if (e === void 0 && (e = g.NONE), !this._blocks.length) return 0;
    const s = new Re(this, t);
    if (e === g.NONE)
      return s.pushRightBeforeInput() || (s.popState(), s.pushLeftBeforeInput()) ? s.pos : this.displayValue.length;
    if (e === g.LEFT || e === g.FORCE_LEFT) {
      if (e === g.LEFT) {
        if (s.pushRightBeforeFilled(), s.ok && s.pos === t) return t;
        s.popState();
      }
      if (s.pushLeftBeforeInput(), s.pushLeftBeforeRequired(), s.pushLeftBeforeFilled(), e === g.LEFT) {
        if (s.pushRightBeforeInput(), s.pushRightBeforeRequired(), s.ok && s.pos <= t || (s.popState(), s.ok && s.pos <= t)) return s.pos;
        s.popState();
      }
      return s.ok ? s.pos : e === g.FORCE_LEFT ? 0 : (s.popState(), s.ok || (s.popState(), s.ok) ? s.pos : 0);
    }
    return e === g.RIGHT || e === g.FORCE_RIGHT ? (s.pushRightBeforeInput(), s.pushRightBeforeRequired(), s.pushRightBeforeFilled() ? s.pos : e === g.FORCE_RIGHT ? this.displayValue.length : (s.popState(), s.ok || (s.popState(), s.ok) ? s.pos : this.nearestInputPos(t, g.LEFT))) : t;
  }
  totalInputPositions(t, e) {
    t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length);
    let s = 0;
    return this._forEachBlocksInRange(t, e, (i, r, n, u) => {
      s += i.totalInputPositions(n, u);
    }), s;
  }
  /** Get block by name */
  maskedBlock(t) {
    return this.maskedBlocks(t)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(t) {
    const e = this._maskedBlocks[t];
    return e ? e.map((s) => this._blocks[s]) : [];
  }
  pad(t) {
    const e = new C();
    return this._forEachBlocksInRange(0, this.displayValue.length, (s) => e.aggregate(s.pad(t))), e;
  }
}
q.DEFAULTS = {
  ...$.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
q.STOP_CHAR = "`";
q.ESCAPE_CHAR = "\\";
q.InputDefinition = _t;
q.FixedDefinition = Jt;
k.MaskedPattern = q;
class mt extends q {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(t) {
    super(t);
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    const {
      to: e = this.to || 0,
      from: s = this.from || 0,
      maxLength: i = this.maxLength || 0,
      autofix: r = this.autofix,
      ...n
    } = t;
    this.to = e, this.from = s, this.maxLength = Math.max(String(e).length, i), this.autofix = r;
    const u = String(this.from).padStart(this.maxLength, "0"), l = String(this.to).padStart(this.maxLength, "0");
    let h = 0;
    for (; h < l.length && l[h] === u[h]; ) ++h;
    n.mask = l.slice(0, h).replace(/0/g, "\\0") + "0".repeat(this.maxLength - h), super._update(n);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(t) {
    let e = "", s = "";
    const [, i, r] = t.match(/^(\D*)(\d*)(\D*)/) || [];
    return r && (e = "0".repeat(i.length) + r, s = "9".repeat(i.length) + r), e = e.padEnd(this.maxLength, "0"), s = s.padEnd(this.maxLength, "9"), [e, s];
  }
  doPrepareChar(t, e) {
    e === void 0 && (e = {});
    let s;
    return [t, s] = super.doPrepareChar(t.replace(/\D/g, ""), e), t || (s.skip = !this.isComplete), [t, s];
  }
  _appendCharRaw(t, e) {
    if (e === void 0 && (e = {}), !this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(t, e);
    const s = String(this.from).padStart(this.maxLength, "0"), i = String(this.to).padStart(this.maxLength, "0"), [r, n] = this.boundaries(this.value + t);
    return Number(n) < this.from ? super._appendCharRaw(s[this.value.length], e) : Number(r) > this.to ? !e.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(s[this.value.length], e).aggregate(this._appendCharRaw(t, e)) : super._appendCharRaw(i[this.value.length], e) : super._appendCharRaw(t, e);
  }
  doValidate(t) {
    const e = this.value;
    if (e.search(/[^0]/) === -1 && e.length <= this._matchFrom) return !0;
    const [i, r] = this.boundaries(e);
    return this.from <= Number(r) && Number(i) <= this.to && super.doValidate(t);
  }
  pad(t) {
    const e = new C();
    if (this.value.length === this.maxLength) return e;
    const s = this.value, i = this.maxLength - this.value.length;
    if (i) {
      this.reset();
      for (let r = 0; r < i; ++r)
        e.aggregate(super._appendCharRaw("0", t));
      s.split("").forEach((r) => this._appendCharRaw(r));
    }
    return e;
  }
}
k.MaskedRange = mt;
const Me = "d{.}`m{.}`Y";
class Q extends q {
  static extractPatternOptions(t) {
    const {
      mask: e,
      pattern: s,
      ...i
    } = t;
    return {
      ...i,
      mask: it(e) ? e : s
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(t) {
    super(Q.extractPatternOptions({
      ...Q.DEFAULTS,
      ...t
    }));
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    const {
      mask: e,
      pattern: s,
      blocks: i,
      ...r
    } = {
      ...Q.DEFAULTS,
      ...t
    }, n = Object.assign({}, Q.GET_DEFAULT_BLOCKS());
    t.min && (n.Y.from = t.min.getFullYear()), t.max && (n.Y.to = t.max.getFullYear()), t.min && t.max && n.Y.from === n.Y.to && (n.m.from = t.min.getMonth() + 1, n.m.to = t.max.getMonth() + 1, n.m.from === n.m.to && (n.d.from = t.min.getDate(), n.d.to = t.max.getDate())), Object.assign(n, this.blocks, i), super._update({
      ...r,
      mask: it(e) ? e : s,
      blocks: n
    });
  }
  doValidate(t) {
    const e = this.date;
    return super.doValidate(t) && (!this.isComplete || this.isDateExist(this.value) && e != null && (this.min == null || this.min <= e) && (this.max == null || e <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(t) {
    return this.format(this.parse(t, this), this).indexOf(t) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(t) {
    this.typedValue = t;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(t) {
    super.typedValue = t;
  }
  maskEquals(t) {
    return t === Date || super.maskEquals(t);
  }
  optionsIsChanged(t) {
    return super.optionsIsChanged(Q.extractPatternOptions(t));
  }
}
Q.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: mt,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: mt,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: mt,
    from: 1900,
    to: 9999
  }
});
Q.DEFAULTS = {
  ...q.DEFAULTS,
  mask: Date,
  pattern: Me,
  format: (a, t) => {
    if (!a) return "";
    const e = String(a.getDate()).padStart(2, "0"), s = String(a.getMonth() + 1).padStart(2, "0"), i = a.getFullYear();
    return [e, s, i].join(".");
  },
  parse: (a, t) => {
    const [e, s, i] = a.split(".").map(Number);
    return new Date(i, s - 1, e);
  }
};
k.MaskedDate = Q;
class Et extends $ {
  constructor(t) {
    super({
      ...Et.DEFAULTS,
      ...t
    }), this.currentMask = void 0;
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    super._update(t), "mask" in t && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(t.mask) ? t.mask.map((e) => {
      const {
        expose: s,
        ...i
      } = ct(e), r = tt({
        overwrite: this._overwrite,
        eager: this._eager,
        skipInvalid: this._skipInvalid,
        ...i
      });
      return s && (this.exposeMask = r), r;
    }) : []);
  }
  _appendCharRaw(t, e) {
    e === void 0 && (e = {});
    const s = this._applyDispatch(t, e);
    return this.currentMask && s.aggregate(this.currentMask._appendChar(t, this.currentMaskFlags(e))), s;
  }
  _applyDispatch(t, e, s) {
    t === void 0 && (t = ""), e === void 0 && (e = {}), s === void 0 && (s = "");
    const i = e.tail && e._beforeTailState != null ? e._beforeTailState._value : this.value, r = this.rawInputValue, n = e.tail && e._beforeTailState != null ? e._beforeTailState._rawInputValue : r, u = r.slice(n.length), l = this.currentMask, h = new C(), _ = l == null ? void 0 : l.state;
    return this.currentMask = this.doDispatch(t, {
      ...e
    }, s), this.currentMask && (this.currentMask !== l ? (this.currentMask.reset(), n && (this.currentMask.append(n, {
      raw: !0
    }), h.tailShift = this.currentMask.value.length - i.length), u && (h.tailShift += this.currentMask.append(u, {
      raw: !0,
      tail: !0
    }).tailShift)) : _ && (this.currentMask.state = _)), h;
  }
  _appendPlaceholder() {
    const t = this._applyDispatch();
    return this.currentMask && t.aggregate(this.currentMask._appendPlaceholder()), t;
  }
  _appendEager() {
    const t = this._applyDispatch();
    return this.currentMask && t.aggregate(this.currentMask._appendEager()), t;
  }
  appendTail(t) {
    const e = new C();
    return t && e.aggregate(this._applyDispatch("", {}, t)), e.aggregate(this.currentMask ? this.currentMask.appendTail(t) : super.appendTail(t));
  }
  currentMaskFlags(t) {
    var e, s;
    return {
      ...t,
      _beforeTailState: ((e = t._beforeTailState) == null ? void 0 : e.currentMaskRef) === this.currentMask && ((s = t._beforeTailState) == null ? void 0 : s.currentMask) || t._beforeTailState
    };
  }
  doDispatch(t, e, s) {
    return e === void 0 && (e = {}), s === void 0 && (s = ""), this.dispatch(t, this, e, s);
  }
  doValidate(t) {
    return super.doValidate(t) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(t)));
  }
  doPrepare(t, e) {
    e === void 0 && (e = {});
    let [s, i] = super.doPrepare(t, e);
    if (this.currentMask) {
      let r;
      [s, r] = super.doPrepare(s, this.currentMaskFlags(e)), i = i.aggregate(r);
    }
    return [s, i];
  }
  doPrepareChar(t, e) {
    e === void 0 && (e = {});
    let [s, i] = super.doPrepareChar(t, e);
    if (this.currentMask) {
      let r;
      [s, r] = super.doPrepareChar(s, this.currentMaskFlags(e)), i = i.aggregate(r);
    }
    return [s, i];
  }
  reset() {
    var t;
    (t = this.currentMask) == null || t.reset(), this.compiledMasks.forEach((e) => e.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(t) {
    this.exposeMask ? (this.exposeMask.value = t, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = t;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(t) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = t, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = t;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(t) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = t, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let e = String(t);
    this.currentMask && (this.currentMask.typedValue = t, e = this.currentMask.unmaskedValue), this.unmaskedValue = e;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var t;
    return !!((t = this.currentMask) != null && t.isComplete);
  }
  get isFilled() {
    var t;
    return !!((t = this.currentMask) != null && t.isFilled);
  }
  remove(t, e) {
    const s = new C();
    return this.currentMask && s.aggregate(this.currentMask.remove(t, e)).aggregate(this._applyDispatch()), s;
  }
  get state() {
    var t;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((e) => e.state),
      currentMaskRef: this.currentMask,
      currentMask: (t = this.currentMask) == null ? void 0 : t.state
    };
  }
  set state(t) {
    const {
      compiledMasks: e,
      currentMaskRef: s,
      currentMask: i,
      ...r
    } = t;
    e && this.compiledMasks.forEach((n, u) => n.state = e[u]), s != null && (this.currentMask = s, this.currentMask.state = i), super.state = r;
  }
  extractInput(t, e, s) {
    return this.currentMask ? this.currentMask.extractInput(t, e, s) : "";
  }
  extractTail(t, e) {
    return this.currentMask ? this.currentMask.extractTail(t, e) : super.extractTail(t, e);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(t, e) {
    return this.currentMask ? this.currentMask.nearestInputPos(t, e) : super.nearestInputPos(t, e);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(t) {
    this._overwrite = t;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(t) {
    this._eager = t;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(t) {
    this._skipInvalid = t;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(t) {
    this._autofix = t;
  }
  maskEquals(t) {
    return Array.isArray(t) ? this.compiledMasks.every((e, s) => {
      if (!t[s]) return;
      const {
        mask: i,
        ...r
      } = t[s];
      return gt(e, r) && e.maskEquals(i);
    }) : super.maskEquals(t);
  }
  typedValueEquals(t) {
    var e;
    return !!((e = this.currentMask) != null && e.typedValueEquals(t));
  }
}
Et.DEFAULTS = {
  ...$.DEFAULTS,
  dispatch: (a, t, e, s) => {
    if (!t.compiledMasks.length) return;
    const i = t.rawInputValue, r = t.compiledMasks.map((n, u) => {
      const l = t.currentMask === n, h = l ? n.displayValue.length : n.nearestInputPos(n.displayValue.length, g.FORCE_LEFT);
      return n.rawInputValue !== i ? (n.reset(), n.append(i, {
        raw: !0
      })) : l || n.remove(h), n.append(a, t.currentMaskFlags(e)), n.appendTail(s), {
        index: u,
        weight: n.rawInputValue.length,
        totalInputPositions: n.totalInputPositions(0, Math.max(h, n.nearestInputPos(n.displayValue.length, g.FORCE_LEFT)))
      };
    });
    return r.sort((n, u) => u.weight - n.weight || u.totalInputPositions - n.totalInputPositions), t.compiledMasks[r[0].index];
  }
};
k.MaskedDynamic = Et;
class yt extends q {
  constructor(t) {
    super({
      ...yt.DEFAULTS,
      ...t
    });
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    const {
      enum: e,
      ...s
    } = t;
    if (e) {
      const i = e.map((u) => u.length), r = Math.min(...i), n = Math.max(...i) - r;
      s.mask = "*".repeat(r), n && (s.mask += "[" + "*".repeat(n) + "]"), this.enum = e;
    }
    super._update(s);
  }
  _appendCharRaw(t, e) {
    e === void 0 && (e = {});
    const s = Math.min(this.nearestInputPos(0, g.FORCE_RIGHT), this.value.length), i = this.enum.filter((r) => this.matchValue(r, this.unmaskedValue + t, s));
    if (i.length) {
      i.length === 1 && this._forEachBlocksInRange(0, this.value.length, (n, u) => {
        const l = i[0][u];
        u >= this.value.length || l === n.value || (n.reset(), n._appendChar(l, e));
      });
      const r = super._appendCharRaw(i[0][this.value.length], e);
      return i.length === 1 && i[0].slice(this.unmaskedValue.length).split("").forEach((n) => r.aggregate(super._appendCharRaw(n))), r;
    }
    return new C({
      skip: !this.isComplete
    });
  }
  extractTail(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), new Z("", t);
  }
  remove(t, e) {
    if (t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), t === e) return new C();
    const s = Math.min(super.nearestInputPos(0, g.FORCE_RIGHT), this.value.length);
    let i;
    for (i = t; i >= 0 && !(this.enum.filter((u) => this.matchValue(u, this.value.slice(s, i), s)).length > 1); --i)
      ;
    const r = super.remove(i, e);
    return r.tailShift += i - t, r;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
yt.DEFAULTS = {
  ...q.DEFAULTS,
  matchValue: (a, t, e) => a.indexOf(t, e) === e
};
k.MaskedEnum = yt;
class Oe extends $ {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    super._update({
      ...t,
      validate: t.mask
    });
  }
}
k.MaskedFunction = Oe;
var Qt;
class z extends $ {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(t) {
    super({
      ...z.DEFAULTS,
      ...t
    });
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    super._update(t), this._updateRegExps();
  }
  _updateRegExps() {
    const t = "^" + (this.allowNegative ? "[+|\\-]?" : ""), e = "\\d*", s = (this.scale ? "(" + bt(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(t + e + s), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(bt).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(bt(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(t) {
    return t.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(t) {
    const e = t.split(this.radix);
    return e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), e.join(this.radix);
  }
  doPrepareChar(t, e) {
    e === void 0 && (e = {});
    const [s, i] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (e.input && e.raw || !e.input && !e.raw) ? t.replace(this._mapToRadixRegExp, this.radix) : t), e);
    return t && !s && (i.skip = !0), s && !this.allowPositive && !this.value && s !== "-" && i.aggregate(this._appendChar("-")), [s, i];
  }
  _separatorsCount(t, e) {
    e === void 0 && (e = !1);
    let s = 0;
    for (let i = 0; i < t; ++i)
      this._value.indexOf(this.thousandsSeparator, i) === i && (++s, e && (t += this.thousandsSeparator.length));
    return s;
  }
  _separatorsCountFromSlice(t) {
    return t === void 0 && (t = this._value), this._separatorsCount(this._removeThousandsSeparators(t).length, !0);
  }
  extractInput(t, e, s) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), [t, e] = this._adjustRangeWithSeparators(t, e), this._removeThousandsSeparators(super.extractInput(t, e, s));
  }
  _appendCharRaw(t, e) {
    e === void 0 && (e = {});
    const s = e.tail && e._beforeTailState ? e._beforeTailState._value : this._value, i = this._separatorsCountFromSlice(s);
    this._value = this._removeThousandsSeparators(this.value);
    const r = this._value;
    this._value += t;
    const n = this.number;
    let u = !isNaN(n), l = !1;
    if (u) {
      let S;
      this.min != null && this.min < 0 && this.number < this.min && (S = this.min), this.max != null && this.max > 0 && this.number > this.max && (S = this.max), S != null && (this.autofix ? (this._value = this.format(S, this).replace(z.UNMASKED_RADIX, this.radix), l || (l = r === this._value && !e.tail)) : u = !1), u && (u = !!this._value.match(this._numberRegExp));
    }
    let h;
    u ? h = new C({
      inserted: this._value.slice(r.length),
      rawInserted: l ? "" : t,
      skip: l
    }) : (this._value = r, h = new C()), this._value = this._insertThousandsSeparators(this._value);
    const _ = e.tail && e._beforeTailState ? e._beforeTailState._value : this._value, v = this._separatorsCountFromSlice(_);
    return h.tailShift += (v - i) * this.thousandsSeparator.length, h;
  }
  _findSeparatorAround(t) {
    if (this.thousandsSeparator) {
      const e = t - this.thousandsSeparator.length + 1, s = this.value.indexOf(this.thousandsSeparator, e);
      if (s <= t) return s;
    }
    return -1;
  }
  _adjustRangeWithSeparators(t, e) {
    const s = this._findSeparatorAround(t);
    s >= 0 && (t = s);
    const i = this._findSeparatorAround(e);
    return i >= 0 && (e = i + this.thousandsSeparator.length), [t, e];
  }
  remove(t, e) {
    t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), [t, e] = this._adjustRangeWithSeparators(t, e);
    const s = this.value.slice(0, t), i = this.value.slice(e), r = this._separatorsCount(s.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(s + i));
    const n = this._separatorsCountFromSlice(s);
    return new C({
      tailShift: (n - r) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(t, e) {
    if (!this.thousandsSeparator) return t;
    switch (e) {
      case g.NONE:
      case g.LEFT:
      case g.FORCE_LEFT: {
        const s = this._findSeparatorAround(t - 1);
        if (s >= 0) {
          const i = s + this.thousandsSeparator.length;
          if (t < i || this.value.length <= i || e === g.FORCE_LEFT)
            return s;
        }
        break;
      }
      case g.RIGHT:
      case g.FORCE_RIGHT: {
        const s = this._findSeparatorAround(t);
        if (s >= 0)
          return s + this.thousandsSeparator.length;
      }
    }
    return t;
  }
  doCommit() {
    if (this.value) {
      const t = this.number;
      let e = t;
      this.min != null && (e = Math.max(e, this.min)), this.max != null && (e = Math.min(e, this.max)), e !== t && (this.unmaskedValue = this.format(e, this));
      let s = this.value;
      this.normalizeZeros && (s = this._normalizeZeros(s)), this.padFractionalZeros && this.scale > 0 && (s = this._padFractionalZeros(s)), this._value = s;
    }
    super.doCommit();
  }
  _normalizeZeros(t) {
    const e = this._removeThousandsSeparators(t).split(this.radix);
    return e[0] = e[0].replace(/^(\D*)(0*)(\d*)/, (s, i, r, n) => i + n), t.length && !/\d$/.test(e[0]) && (e[0] = e[0] + "0"), e.length > 1 && (e[1] = e[1].replace(/0*$/, ""), e[1].length || (e.length = 1)), this._insertThousandsSeparators(e.join(this.radix));
  }
  _padFractionalZeros(t) {
    if (!t) return t;
    const e = t.split(this.radix);
    return e.length < 2 && e.push(""), e[1] = e[1].padEnd(this.scale, "0"), e.join(this.radix);
  }
  doSkipInvalid(t, e, s) {
    e === void 0 && (e = {});
    const i = this.scale === 0 && t !== this.thousandsSeparator && (t === this.radix || t === z.UNMASKED_RADIX || this.mapToRadix.includes(t));
    return super.doSkipInvalid(t, e, s) && !i;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, z.UNMASKED_RADIX);
  }
  set unmaskedValue(t) {
    super.unmaskedValue = t;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(t) {
    this.rawInputValue = this.format(t, this).replace(z.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(t) {
    this.typedValue = t;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(t) {
    return (super.typedValueEquals(t) || z.EMPTY_VALUES.includes(t) && z.EMPTY_VALUES.includes(this.typedValue)) && !(t === 0 && this.value === "");
  }
}
Qt = z;
z.UNMASKED_RADIX = ".";
z.EMPTY_VALUES = [...$.EMPTY_VALUES, 0];
z.DEFAULTS = {
  ...$.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [Qt.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (a) => a.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
k.MaskedNumber = z;
const Rt = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function te(a, t, e) {
  t === void 0 && (t = Rt.MASKED), e === void 0 && (e = Rt.MASKED);
  const s = tt(a);
  return (i) => s.runIsolated((r) => (r[t] = i, r[e]));
}
function De(a, t, e, s) {
  return te(t, e, s)(a);
}
k.PIPE_TYPE = Rt;
k.createPipe = te;
k.pipe = De;
class Ve extends q {
  get repeatFrom() {
    var t;
    return (t = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? t : 0;
  }
  get repeatTo() {
    var t;
    return (t = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? t : 1 / 0;
  }
  constructor(t) {
    super(t);
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    var e, s, i;
    const {
      repeat: r,
      ...n
    } = ct(t);
    this._blockOpts = Object.assign({}, this._blockOpts, n);
    const u = tt(this._blockOpts);
    this.repeat = (e = (s = r ?? u.repeat) != null ? s : this.repeat) != null ? e : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((i = this._blocks) == null ? void 0 : i.length) || 0, this.repeatFrom)),
      blocks: {
        m: u
      },
      eager: u.eager,
      overwrite: u.overwrite,
      skipInvalid: u.skipInvalid,
      lazy: u.lazy,
      placeholderChar: u.placeholderChar,
      displayChar: u.displayChar
    });
  }
  _allocateBlock(t) {
    if (t < this._blocks.length) return this._blocks[t];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo)
      return this._blocks.push(tt(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(t, e) {
    e === void 0 && (e = {});
    const s = new C();
    for (
      let l = (i = (r = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : r.index) != null ? i : Math.max(this._blocks.length - 1, 0), h, _;
      // try to get a block or
      // try to allocate a new block if not allocated already
      h = (n = this._blocks[l]) != null ? n : _ = !_ && this._allocateBlock(l);
      ++l
    ) {
      var i, r, n, u;
      const v = h._appendChar(t, {
        ...e,
        _beforeTailState: (u = e._beforeTailState) == null || (u = u._blocks) == null ? void 0 : u[l]
      });
      if (v.skip && _) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (s.aggregate(v), v.consumed) break;
    }
    return s;
  }
  _trimEmptyTail(t, e) {
    var s, i;
    t === void 0 && (t = 0);
    const r = Math.max(((s = this._mapPosToBlock(t)) == null ? void 0 : s.index) || 0, this.repeatFrom, 0);
    let n;
    e != null && (n = (i = this._mapPosToBlock(e)) == null ? void 0 : i.index), n == null && (n = this._blocks.length - 1);
    let u = 0;
    for (let l = n; r <= l && !this._blocks[l].unmaskedValue; --l, ++u)
      ;
    u && (this._blocks.splice(n - u + 1, u), this.mask = this.mask.slice(u));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(t, e) {
    t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length);
    const s = super.remove(t, e);
    return this._trimEmptyTail(t, e), s;
  }
  totalInputPositions(t, e) {
    return t === void 0 && (t = 0), e == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(t, e);
  }
  get state() {
    return super.state;
  }
  set state(t) {
    this._blocks.length = t._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = t;
  }
}
k.RepeatBlock = Ve;
try {
  globalThis.IMask = k;
} catch {
}
var Bt = { exports: {} }, ft = { exports: {} }, B = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jt;
function Pe() {
  if (jt) return B;
  jt = 1;
  var a = typeof Symbol == "function" && Symbol.for, t = a ? Symbol.for("react.element") : 60103, e = a ? Symbol.for("react.portal") : 60106, s = a ? Symbol.for("react.fragment") : 60107, i = a ? Symbol.for("react.strict_mode") : 60108, r = a ? Symbol.for("react.profiler") : 60114, n = a ? Symbol.for("react.provider") : 60109, u = a ? Symbol.for("react.context") : 60110, l = a ? Symbol.for("react.async_mode") : 60111, h = a ? Symbol.for("react.concurrent_mode") : 60111, _ = a ? Symbol.for("react.forward_ref") : 60112, v = a ? Symbol.for("react.suspense") : 60113, S = a ? Symbol.for("react.suspense_list") : 60120, R = a ? Symbol.for("react.memo") : 60115, P = a ? Symbol.for("react.lazy") : 60116, I = a ? Symbol.for("react.block") : 60121, O = a ? Symbol.for("react.fundamental") : 60117, U = a ? Symbol.for("react.responder") : 60118, X = a ? Symbol.for("react.scope") : 60119;
  function L(c) {
    if (typeof c == "object" && c !== null) {
      var K = c.$$typeof;
      switch (K) {
        case t:
          switch (c = c.type, c) {
            case l:
            case h:
            case s:
            case r:
            case i:
            case v:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case u:
                case _:
                case P:
                case R:
                case n:
                  return c;
                default:
                  return K;
              }
          }
        case e:
          return K;
      }
    }
  }
  function N(c) {
    return L(c) === h;
  }
  return B.AsyncMode = l, B.ConcurrentMode = h, B.ContextConsumer = u, B.ContextProvider = n, B.Element = t, B.ForwardRef = _, B.Fragment = s, B.Lazy = P, B.Memo = R, B.Portal = e, B.Profiler = r, B.StrictMode = i, B.Suspense = v, B.isAsyncMode = function(c) {
    return N(c) || L(c) === l;
  }, B.isConcurrentMode = N, B.isContextConsumer = function(c) {
    return L(c) === u;
  }, B.isContextProvider = function(c) {
    return L(c) === n;
  }, B.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === t;
  }, B.isForwardRef = function(c) {
    return L(c) === _;
  }, B.isFragment = function(c) {
    return L(c) === s;
  }, B.isLazy = function(c) {
    return L(c) === P;
  }, B.isMemo = function(c) {
    return L(c) === R;
  }, B.isPortal = function(c) {
    return L(c) === e;
  }, B.isProfiler = function(c) {
    return L(c) === r;
  }, B.isStrictMode = function(c) {
    return L(c) === i;
  }, B.isSuspense = function(c) {
    return L(c) === v;
  }, B.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === s || c === h || c === r || c === i || c === v || c === S || typeof c == "object" && c !== null && (c.$$typeof === P || c.$$typeof === R || c.$$typeof === n || c.$$typeof === u || c.$$typeof === _ || c.$$typeof === O || c.$$typeof === U || c.$$typeof === X || c.$$typeof === I);
  }, B.typeOf = L, B;
}
var M = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ut;
function Le() {
  return Ut || (Ut = 1, process.env.NODE_ENV !== "production" && function() {
    var a = typeof Symbol == "function" && Symbol.for, t = a ? Symbol.for("react.element") : 60103, e = a ? Symbol.for("react.portal") : 60106, s = a ? Symbol.for("react.fragment") : 60107, i = a ? Symbol.for("react.strict_mode") : 60108, r = a ? Symbol.for("react.profiler") : 60114, n = a ? Symbol.for("react.provider") : 60109, u = a ? Symbol.for("react.context") : 60110, l = a ? Symbol.for("react.async_mode") : 60111, h = a ? Symbol.for("react.concurrent_mode") : 60111, _ = a ? Symbol.for("react.forward_ref") : 60112, v = a ? Symbol.for("react.suspense") : 60113, S = a ? Symbol.for("react.suspense_list") : 60120, R = a ? Symbol.for("react.memo") : 60115, P = a ? Symbol.for("react.lazy") : 60116, I = a ? Symbol.for("react.block") : 60121, O = a ? Symbol.for("react.fundamental") : 60117, U = a ? Symbol.for("react.responder") : 60118, X = a ? Symbol.for("react.scope") : 60119;
    function L(p) {
      return typeof p == "string" || typeof p == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      p === s || p === h || p === r || p === i || p === v || p === S || typeof p == "object" && p !== null && (p.$$typeof === P || p.$$typeof === R || p.$$typeof === n || p.$$typeof === u || p.$$typeof === _ || p.$$typeof === O || p.$$typeof === U || p.$$typeof === X || p.$$typeof === I);
    }
    function N(p) {
      if (typeof p == "object" && p !== null) {
        var W = p.$$typeof;
        switch (W) {
          case t:
            var dt = p.type;
            switch (dt) {
              case l:
              case h:
              case s:
              case r:
              case i:
              case v:
                return dt;
              default:
                var Dt = dt && dt.$$typeof;
                switch (Dt) {
                  case u:
                  case _:
                  case P:
                  case R:
                  case n:
                    return Dt;
                  default:
                    return W;
                }
            }
          case e:
            return W;
        }
      }
    }
    var c = l, K = h, et = u, G = n, st = t, ht = _, at = s, ut = P, rt = R, j = e, ot = r, H = i, J = v, lt = !1;
    function pt(p) {
      return lt || (lt = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), o(p) || N(p) === l;
    }
    function o(p) {
      return N(p) === h;
    }
    function d(p) {
      return N(p) === u;
    }
    function F(p) {
      return N(p) === n;
    }
    function A(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }
    function E(p) {
      return N(p) === _;
    }
    function T(p) {
      return N(p) === s;
    }
    function y(p) {
      return N(p) === P;
    }
    function b(p) {
      return N(p) === R;
    }
    function f(p) {
      return N(p) === e;
    }
    function x(p) {
      return N(p) === r;
    }
    function w(p) {
      return N(p) === i;
    }
    function Y(p) {
      return N(p) === v;
    }
    M.AsyncMode = c, M.ConcurrentMode = K, M.ContextConsumer = et, M.ContextProvider = G, M.Element = st, M.ForwardRef = ht, M.Fragment = at, M.Lazy = ut, M.Memo = rt, M.Portal = j, M.Profiler = ot, M.StrictMode = H, M.Suspense = J, M.isAsyncMode = pt, M.isConcurrentMode = o, M.isContextConsumer = d, M.isContextProvider = F, M.isElement = A, M.isForwardRef = E, M.isFragment = T, M.isLazy = y, M.isMemo = b, M.isPortal = f, M.isProfiler = x, M.isStrictMode = w, M.isSuspense = Y, M.isValidElementType = L, M.typeOf = N;
  }()), M;
}
var $t;
function ee() {
  return $t || ($t = 1, process.env.NODE_ENV === "production" ? ft.exports = Pe() : ft.exports = Le()), ft.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var xt, qt;
function Ne() {
  if (qt) return xt;
  qt = 1;
  var a = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, e = Object.prototype.propertyIsEnumerable;
  function s(r) {
    if (r == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(r);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var r = new String("abc");
      if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5")
        return !1;
      for (var n = {}, u = 0; u < 10; u++)
        n["_" + String.fromCharCode(u)] = u;
      var l = Object.getOwnPropertyNames(n).map(function(_) {
        return n[_];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var h = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(_) {
        h[_] = _;
      }), Object.keys(Object.assign({}, h)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return xt = i() ? Object.assign : function(r, n) {
    for (var u, l = s(r), h, _ = 1; _ < arguments.length; _++) {
      u = Object(arguments[_]);
      for (var v in u)
        t.call(u, v) && (l[v] = u[v]);
      if (a) {
        h = a(u);
        for (var S = 0; S < h.length; S++)
          e.call(u, h[S]) && (l[h[S]] = u[h[S]]);
      }
    }
    return l;
  }, xt;
}
var Ft, Yt;
function Ot() {
  if (Yt) return Ft;
  Yt = 1;
  var a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ft = a, Ft;
}
var St, zt;
function se() {
  return zt || (zt = 1, St = Function.call.bind(Object.prototype.hasOwnProperty)), St;
}
var Tt, Ht;
function je() {
  if (Ht) return Tt;
  Ht = 1;
  var a = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Ot(), e = {}, s = se();
    a = function(r) {
      var n = "Warning: " + r;
      typeof console < "u" && console.error(n);
      try {
        throw new Error(n);
      } catch {
      }
    };
  }
  function i(r, n, u, l, h) {
    if (process.env.NODE_ENV !== "production") {
      for (var _ in r)
        if (s(r, _)) {
          var v;
          try {
            if (typeof r[_] != "function") {
              var S = Error(
                (l || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw S.name = "Invariant Violation", S;
            }
            v = r[_](n, _, l, u, null, t);
          } catch (P) {
            v = P;
          }
          if (v && !(v instanceof Error) && a(
            (l || "React class") + ": type specification of " + u + " `" + _ + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof v + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), v instanceof Error && !(v.message in e)) {
            e[v.message] = !0;
            var R = h ? h() : "";
            a(
              "Failed " + u + " type: " + v.message + (R ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (e = {});
  }, Tt = i, Tt;
}
var wt, Kt;
function Ue() {
  if (Kt) return wt;
  Kt = 1;
  var a = ee(), t = Ne(), e = Ot(), s = se(), i = je(), r = function() {
  };
  process.env.NODE_ENV !== "production" && (r = function(u) {
    var l = "Warning: " + u;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function n() {
    return null;
  }
  return wt = function(u, l) {
    var h = typeof Symbol == "function" && Symbol.iterator, _ = "@@iterator";
    function v(o) {
      var d = o && (h && o[h] || o[_]);
      if (typeof d == "function")
        return d;
    }
    var S = "<<anonymous>>", R = {
      array: U("array"),
      bigint: U("bigint"),
      bool: U("boolean"),
      func: U("function"),
      number: U("number"),
      object: U("object"),
      string: U("string"),
      symbol: U("symbol"),
      any: X(),
      arrayOf: L,
      element: N(),
      elementType: c(),
      instanceOf: K,
      node: ht(),
      objectOf: G,
      oneOf: et,
      oneOfType: st,
      shape: ut,
      exact: rt
    };
    function P(o, d) {
      return o === d ? o !== 0 || 1 / o === 1 / d : o !== o && d !== d;
    }
    function I(o, d) {
      this.message = o, this.data = d && typeof d == "object" ? d : {}, this.stack = "";
    }
    I.prototype = Error.prototype;
    function O(o) {
      if (process.env.NODE_ENV !== "production")
        var d = {}, F = 0;
      function A(T, y, b, f, x, w, Y) {
        if (f = f || S, w = w || b, Y !== e) {
          if (l) {
            var p = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw p.name = "Invariant Violation", p;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var W = f + ":" + b;
            !d[W] && // Avoid spamming the console because they are often not actionable except for lib authors
            F < 3 && (r(
              "You are manually calling a React.PropTypes validation function for the `" + w + "` prop on `" + f + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), d[W] = !0, F++);
          }
        }
        return y[b] == null ? T ? y[b] === null ? new I("The " + x + " `" + w + "` is marked as required " + ("in `" + f + "`, but its value is `null`.")) : new I("The " + x + " `" + w + "` is marked as required in " + ("`" + f + "`, but its value is `undefined`.")) : null : o(y, b, f, x, w);
      }
      var E = A.bind(null, !1);
      return E.isRequired = A.bind(null, !0), E;
    }
    function U(o) {
      function d(F, A, E, T, y, b) {
        var f = F[A], x = H(f);
        if (x !== o) {
          var w = J(f);
          return new I(
            "Invalid " + T + " `" + y + "` of type " + ("`" + w + "` supplied to `" + E + "`, expected ") + ("`" + o + "`."),
            { expectedType: o }
          );
        }
        return null;
      }
      return O(d);
    }
    function X() {
      return O(n);
    }
    function L(o) {
      function d(F, A, E, T, y) {
        if (typeof o != "function")
          return new I("Property `" + y + "` of component `" + E + "` has invalid PropType notation inside arrayOf.");
        var b = F[A];
        if (!Array.isArray(b)) {
          var f = H(b);
          return new I("Invalid " + T + " `" + y + "` of type " + ("`" + f + "` supplied to `" + E + "`, expected an array."));
        }
        for (var x = 0; x < b.length; x++) {
          var w = o(b, x, E, T, y + "[" + x + "]", e);
          if (w instanceof Error)
            return w;
        }
        return null;
      }
      return O(d);
    }
    function N() {
      function o(d, F, A, E, T) {
        var y = d[F];
        if (!u(y)) {
          var b = H(y);
          return new I("Invalid " + E + " `" + T + "` of type " + ("`" + b + "` supplied to `" + A + "`, expected a single ReactElement."));
        }
        return null;
      }
      return O(o);
    }
    function c() {
      function o(d, F, A, E, T) {
        var y = d[F];
        if (!a.isValidElementType(y)) {
          var b = H(y);
          return new I("Invalid " + E + " `" + T + "` of type " + ("`" + b + "` supplied to `" + A + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return O(o);
    }
    function K(o) {
      function d(F, A, E, T, y) {
        if (!(F[A] instanceof o)) {
          var b = o.name || S, f = pt(F[A]);
          return new I("Invalid " + T + " `" + y + "` of type " + ("`" + f + "` supplied to `" + E + "`, expected ") + ("instance of `" + b + "`."));
        }
        return null;
      }
      return O(d);
    }
    function et(o) {
      if (!Array.isArray(o))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? r(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : r("Invalid argument supplied to oneOf, expected an array.")), n;
      function d(F, A, E, T, y) {
        for (var b = F[A], f = 0; f < o.length; f++)
          if (P(b, o[f]))
            return null;
        var x = JSON.stringify(o, function(Y, p) {
          var W = J(p);
          return W === "symbol" ? String(p) : p;
        });
        return new I("Invalid " + T + " `" + y + "` of value `" + String(b) + "` " + ("supplied to `" + E + "`, expected one of " + x + "."));
      }
      return O(d);
    }
    function G(o) {
      function d(F, A, E, T, y) {
        if (typeof o != "function")
          return new I("Property `" + y + "` of component `" + E + "` has invalid PropType notation inside objectOf.");
        var b = F[A], f = H(b);
        if (f !== "object")
          return new I("Invalid " + T + " `" + y + "` of type " + ("`" + f + "` supplied to `" + E + "`, expected an object."));
        for (var x in b)
          if (s(b, x)) {
            var w = o(b, x, E, T, y + "." + x, e);
            if (w instanceof Error)
              return w;
          }
        return null;
      }
      return O(d);
    }
    function st(o) {
      if (!Array.isArray(o))
        return process.env.NODE_ENV !== "production" && r("Invalid argument supplied to oneOfType, expected an instance of array."), n;
      for (var d = 0; d < o.length; d++) {
        var F = o[d];
        if (typeof F != "function")
          return r(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + lt(F) + " at index " + d + "."
          ), n;
      }
      function A(E, T, y, b, f) {
        for (var x = [], w = 0; w < o.length; w++) {
          var Y = o[w], p = Y(E, T, y, b, f, e);
          if (p == null)
            return null;
          p.data && s(p.data, "expectedType") && x.push(p.data.expectedType);
        }
        var W = x.length > 0 ? ", expected one of type [" + x.join(", ") + "]" : "";
        return new I("Invalid " + b + " `" + f + "` supplied to " + ("`" + y + "`" + W + "."));
      }
      return O(A);
    }
    function ht() {
      function o(d, F, A, E, T) {
        return j(d[F]) ? null : new I("Invalid " + E + " `" + T + "` supplied to " + ("`" + A + "`, expected a ReactNode."));
      }
      return O(o);
    }
    function at(o, d, F, A, E) {
      return new I(
        (o || "React class") + ": " + d + " type `" + F + "." + A + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + E + "`."
      );
    }
    function ut(o) {
      function d(F, A, E, T, y) {
        var b = F[A], f = H(b);
        if (f !== "object")
          return new I("Invalid " + T + " `" + y + "` of type `" + f + "` " + ("supplied to `" + E + "`, expected `object`."));
        for (var x in o) {
          var w = o[x];
          if (typeof w != "function")
            return at(E, T, y, x, J(w));
          var Y = w(b, x, E, T, y + "." + x, e);
          if (Y)
            return Y;
        }
        return null;
      }
      return O(d);
    }
    function rt(o) {
      function d(F, A, E, T, y) {
        var b = F[A], f = H(b);
        if (f !== "object")
          return new I("Invalid " + T + " `" + y + "` of type `" + f + "` " + ("supplied to `" + E + "`, expected `object`."));
        var x = t({}, F[A], o);
        for (var w in x) {
          var Y = o[w];
          if (s(o, w) && typeof Y != "function")
            return at(E, T, y, w, J(Y));
          if (!Y)
            return new I(
              "Invalid " + T + " `" + y + "` key `" + w + "` supplied to `" + E + "`.\nBad object: " + JSON.stringify(F[A], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(o), null, "  ")
            );
          var p = Y(b, w, E, T, y + "." + w, e);
          if (p)
            return p;
        }
        return null;
      }
      return O(d);
    }
    function j(o) {
      switch (typeof o) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !o;
        case "object":
          if (Array.isArray(o))
            return o.every(j);
          if (o === null || u(o))
            return !0;
          var d = v(o);
          if (d) {
            var F = d.call(o), A;
            if (d !== o.entries) {
              for (; !(A = F.next()).done; )
                if (!j(A.value))
                  return !1;
            } else
              for (; !(A = F.next()).done; ) {
                var E = A.value;
                if (E && !j(E[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ot(o, d) {
      return o === "symbol" ? !0 : d ? d["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && d instanceof Symbol : !1;
    }
    function H(o) {
      var d = typeof o;
      return Array.isArray(o) ? "array" : o instanceof RegExp ? "object" : ot(d, o) ? "symbol" : d;
    }
    function J(o) {
      if (typeof o > "u" || o === null)
        return "" + o;
      var d = H(o);
      if (d === "object") {
        if (o instanceof Date)
          return "date";
        if (o instanceof RegExp)
          return "regexp";
      }
      return d;
    }
    function lt(o) {
      var d = J(o);
      switch (d) {
        case "array":
        case "object":
          return "an " + d;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + d;
        default:
          return d;
      }
    }
    function pt(o) {
      return !o.constructor || !o.constructor.name ? S : o.constructor.name;
    }
    return R.checkPropTypes = i, R.resetWarningCache = i.resetWarningCache, R.PropTypes = R, R;
  }, wt;
}
var It, Gt;
function $e() {
  if (Gt) return It;
  Gt = 1;
  var a = Ot();
  function t() {
  }
  function e() {
  }
  return e.resetWarningCache = t, It = function() {
    function s(n, u, l, h, _, v) {
      if (v !== a) {
        var S = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw S.name = "Invariant Violation", S;
      }
    }
    s.isRequired = s;
    function i() {
      return s;
    }
    var r = {
      array: s,
      bigint: s,
      bool: s,
      func: s,
      number: s,
      object: s,
      string: s,
      symbol: s,
      any: s,
      arrayOf: i,
      element: s,
      elementType: s,
      instanceOf: i,
      node: s,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: e,
      resetWarningCache: t
    };
    return r.PropTypes = r, r;
  }, It;
}
if (process.env.NODE_ENV !== "production") {
  var qe = ee(), Ye = !0;
  Bt.exports = Ue()(qe.isElement, Ye);
} else
  Bt.exports = $e()();
var ze = Bt.exports;
const m = /* @__PURE__ */ ce(ze), ie = {
  // common
  mask: m.oneOfType([m.array, m.func, m.string, m.instanceOf(RegExp), m.oneOf([Date, Number, k.Masked]), m.instanceOf(k.Masked)]),
  value: m.any,
  unmask: m.oneOfType([m.bool, m.oneOf(["typed"])]),
  prepare: m.func,
  prepareChar: m.func,
  validate: m.func,
  commit: m.func,
  overwrite: m.oneOfType([m.bool, m.oneOf(["shift"])]),
  eager: m.oneOfType([m.bool, m.oneOf(["append", "remove"])]),
  skipInvalid: m.bool,
  // events
  onAccept: m.func,
  onComplete: m.func,
  // pattern
  placeholderChar: m.string,
  displayChar: m.string,
  lazy: m.bool,
  definitions: m.object,
  blocks: m.object,
  // enum
  enum: m.arrayOf(m.string),
  // range
  maxLength: m.number,
  from: m.number,
  to: m.number,
  // date
  pattern: m.string,
  format: m.func,
  parse: m.func,
  autofix: m.oneOfType([m.bool, m.oneOf(["pad"])]),
  // number
  radix: m.string,
  thousandsSeparator: m.string,
  mapToRadix: m.arrayOf(m.string),
  scale: m.number,
  normalizeZeros: m.bool,
  padFractionalZeros: m.bool,
  min: m.oneOfType([m.number, m.instanceOf(Date)]),
  max: m.oneOfType([m.number, m.instanceOf(Date)]),
  // dynamic
  dispatch: m.func,
  // ref
  inputRef: m.oneOfType([m.func, m.shape({
    current: m.object
  })])
}, re = Object.keys(ie).filter((a) => a !== "value"), He = ["value", "unmask", "onAccept", "onComplete", "inputRef"], Ke = re.filter((a) => He.indexOf(a) < 0);
function Ge(a) {
  var t;
  const e = (t = class extends D.Component {
    constructor(r) {
      super(r), this._inputRef = this._inputRef.bind(this);
    }
    componentDidMount() {
      this.props.mask && this.initMask();
    }
    componentDidUpdate() {
      const r = this.props, n = this._extractMaskOptionsFromProps(r);
      if (n.mask)
        this.maskRef ? (this.maskRef.updateOptions(n), "value" in r && r.value !== void 0 && (this.maskValue = r.value)) : this.initMask(n);
      else if (this.destroyMask(), "value" in r && r.value !== void 0) {
        var u;
        (u = this.element) != null && u.isContentEditable && this.element.tagName !== "INPUT" && this.element.tagName !== "TEXTAREA" ? this.element.textContent = r.value : this.element.value = r.value;
      }
    }
    componentWillUnmount() {
      this.destroyMask();
    }
    _inputRef(r) {
      this.element = r, this.props.inputRef && (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current") ? this.props.inputRef.current = r : this.props.inputRef(r));
    }
    initMask(r) {
      r === void 0 && (r = this._extractMaskOptionsFromProps(this.props)), this.maskRef = k(this.element, r).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this)), "value" in this.props && this.props.value !== void 0 && (this.maskValue = this.props.value);
    }
    destroyMask() {
      this.maskRef && (this.maskRef.destroy(), delete this.maskRef);
    }
    _extractMaskOptionsFromProps(r) {
      const {
        ...n
      } = r;
      return Object.keys(n).filter((u) => Ke.indexOf(u) < 0).forEach((u) => {
        delete n[u];
      }), n;
    }
    _extractNonMaskProps(r) {
      const {
        ...n
      } = r;
      return re.forEach((u) => {
        u !== "maxLength" && delete n[u];
      }), "defaultValue" in n || (n.defaultValue = r.mask ? "" : n.value), delete n.value, n;
    }
    get maskValue() {
      return this.maskRef ? this.props.unmask === "typed" ? this.maskRef.typedValue : this.props.unmask ? this.maskRef.unmaskedValue : this.maskRef.value : "";
    }
    set maskValue(r) {
      this.maskRef && (r = r == null && this.props.unmask !== "typed" ? "" : r, this.props.unmask === "typed" ? this.maskRef.typedValue = r : this.props.unmask ? this.maskRef.unmaskedValue = r : this.maskRef.value = r);
    }
    _onAccept(r) {
      this.props.onAccept && this.maskRef && this.props.onAccept(this.maskValue, this.maskRef, r);
    }
    _onComplete(r) {
      this.props.onComplete && this.maskRef && this.props.onComplete(this.maskValue, this.maskRef, r);
    }
    render() {
      return D.createElement(a, {
        ...this._extractNonMaskProps(this.props),
        inputRef: this._inputRef
      });
    }
  }, t.displayName = void 0, t.propTypes = void 0, t), s = a.displayName || a.name || "Component";
  return e.displayName = "IMask(" + s + ")", e.propTypes = ie, D.forwardRef((i, r) => D.createElement(e, {
    ...i,
    ref: r
  }));
}
const We = Ge((a) => {
  let {
    inputRef: t,
    ...e
  } = a;
  return D.createElement("input", {
    ...e,
    ref: t
  });
}), Ze = (a, t) => D.createElement(We, {
  ...a,
  ref: t
}), Xe = D.forwardRef(Ze), Je = ae(
  ({
    "aria-label": a,
    autocomplete: t = "off",
    id: e,
    className: s,
    "data-testid": i,
    disabled: r,
    informativePopover: n,
    error: u,
    errorMessage: l,
    glyph: h,
    glyphPosition: _ = "left",
    helperText: v,
    label: S,
    loading: R,
    customMask: P,
    maxLength: I,
    onGlyphClick: O,
    onChange: U,
    onKeyDown: X,
    prefix: L,
    showCharacterCounter: N,
    size: c = "medium",
    suffix: K,
    type: et,
    value: G,
    ...st
  }, ht) => {
    const [at, ut] = Vt(0), [rt] = Vt(e ?? le(":ride:")), j = ue(null);
    Pt(() => {
      ut((G == null ? void 0 : G.length) || 0);
    }, [G]), oe(ht, () => j.current);
    const ot = (f) => f.preventDefault();
    Pt(() => {
      var f;
      return (f = j.current) == null || f.addEventListener("wheel", ot), () => {
        var x;
        (x = j.current) == null || x.removeEventListener("wheel", ot);
      };
    }, [j]);
    const H = (f) => {
      f.stopPropagation(), O && typeof O == "function" && O(f);
    }, J = (f) => {
      f.stopPropagation(), (f.code === "Space" || f.code === "Enter") && O && typeof O == "function" && O(f);
    }, lt = (f) => {
      const x = f.target.value;
      ut(x.length), U && typeof U == "function" && U(f);
    }, pt = () => At(s, V["ride-text-field"], V[c], {
      [V.disabled]: r,
      [V.loading]: R,
      [V.error]: !r && !R && u
    }), o = () => {
      if (!r && u && l)
        return /* @__PURE__ */ D.createElement(ne, { message: l });
      if (v)
        return /* @__PURE__ */ D.createElement("div", { className: V["helper-container"] }, /* @__PURE__ */ D.createElement("p", { className: V["helper-text"] }, v));
      if (N && I !== void 0 && I >= 0)
        return /* @__PURE__ */ D.createElement("div", { className: V["helper-container"] }, /* @__PURE__ */ D.createElement(
          "span",
          {
            className: V["character-counter"]
          },
          `${at}/${I}`
        ));
    }, d = () => {
      if (R)
        return /* @__PURE__ */ D.createElement(he, { className: V.spinner, size: "large" });
      if (K) return /* @__PURE__ */ D.createElement("span", { className: V.suffix }, K);
      if (!h || _ !== "right") return null;
      const f = Ct(h, {
        fill: "currentColor",
        size: "x-large"
      });
      return /* @__PURE__ */ D.createElement("div", { className: At(V["glyph-container"], V["glyph-right"]) }, /* @__PURE__ */ D.createElement(
        "button",
        {
          className: V["glyph-button"],
          onClick: (x) => H(x),
          onKeyDown: (x) => J(x),
          type: "button",
          "aria-label": "glyph-button"
        },
        f
      ));
    }, F = () => {
      if (R) return null;
      if (L) return /* @__PURE__ */ D.createElement("span", { className: V.prefix }, L);
      if (!h || _ !== "left") return null;
      const f = Ct(h, {
        fill: "currentColor",
        size: "x-large"
      });
      return /* @__PURE__ */ D.createElement("div", { className: At(V["glyph-container"], V["glyph-left"]) }, f);
    }, A = () => et && de.includes(et) ? et : "text", E = () => {
      var f;
      j && ((f = j == null ? void 0 : j.current) == null || f.focus());
    }, T = () => n ? Ct(n, { size: "small" }) : null, y = (f) => {
      et === "number" && ["ArrowUp", "ArrowDown", "-", "+", "e"].includes(f.code) && f.preventDefault(), X == null || X(f);
    }, b = () => {
      if (P) {
        const f = P && typeof P == "string" ? pe[P] : {};
        return /* @__PURE__ */ D.createElement(
          Xe,
          {
            ...f,
            ...st,
            "aria-label": a,
            autoComplete: t,
            className: V.input,
            disabled: r || R,
            id: rt,
            maxLength: I,
            onKeyDown: y,
            inputRef: j,
            value: G
          }
        );
      }
      return /* @__PURE__ */ D.createElement(
        "input",
        {
          ...st,
          value: G,
          "aria-label": a,
          autoComplete: t,
          className: V.input,
          disabled: r || R,
          id: rt,
          maxLength: I,
          onChange: lt,
          onKeyDown: y,
          ref: j,
          type: A()
        }
      );
    };
    return /* @__PURE__ */ D.createElement("div", { "data-testid": i, className: pt() }, S && /* @__PURE__ */ D.createElement("label", { className: V.label, htmlFor: rt }, S, !(st.required || st["aria-required"]) && /* @__PURE__ */ D.createElement("span", { className: V.optional }, "(opcional)"), T()), /* @__PURE__ */ D.createElement(
      "div",
      {
        className: V["input-container"],
        onClick: E
      },
      F(),
      b(),
      d()
    ), o());
  }
);
Je.displayName = "RideTextField";
export {
  Je as RideTextField
};
